import { render, staticRenderFns } from "./tongueIcon.vue?vue&type=template&id=c394e1d4&scoped=true&"
var script = {}
import style0 from "./tongueIcon.vue?vue&type=style&index=0&id=c394e1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c394e1d4",
  null
  
)

export default component.exports